module.exports = __webpack_public_path__ + "img/199.4936e3f5.jpg";